















































































































































































































































































import Vue from 'vue';
import max from 'lodash/max';
import min from 'lodash/min';
import sum from 'lodash/sum';
import { SHIP_TYPE } from '@/classes/const';
import Enemy from '@/classes/enemy/enemy';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import Fleet from '@/classes/fleet/fleet';
import Ship from '@/classes/fleet/ship';
import Item from '@/classes/item/item';
import ItemMaster from '@/classes/item/itemMaster';
import AerialFirePowerCalculator from '@/classes/aerialCombat/powerCalculator';
import CommonCalc from '@/classes/commonCalc';

interface DamageRow {
  enemy: Enemy;
  damage: string;
  death: number;
  taiha: number;
  chuha: number;
}

export default Vue.extend({
  name: 'AntiSubmarineSupport',
  props: {
    fleet: {
      type: Fleet,
      required: true,
    },
  },
  data: () => ({
    enemies: [] as Enemy[],
    displayPrincess: false,
    selectedShipIndex: 0,
    selectedItemIndex: 0,
    slot: 18,
    asw: 10,
    isCritical: false,
    enemyRows: [] as DamageRow[],
    powers: [] as string[],
    rules: {
      counter: (value: number) => (value <= 999 && value >= 0) || '0 ~ 999までが有効です。',
    },
  }),
  mounted() {
    const enemies = this.$store.getters.getEnemies as EnemyMaster[];
    const items = this.$store.state.items as ItemMaster[];

    for (let i = 0; i < enemies.length; i += 1) {
      const enemy = enemies[i];

      if (enemy.type === SHIP_TYPE.SS || enemy.type === SHIP_TYPE.SSV) {
        this.enemies.push(Enemy.createEnemyFromMaster(enemy, false, items));
      }
    }

    if (this.enabledShips.length) {
      this.clickedShip(0);
    } else {
      this.calculate();
    }
  },
  computed: {
    enabledShips(): Ship[] {
      return this.fleet.ships.filter((v) => v.items.some((w) => w.fullSlot));
    },
    items(): Item[] {
      const ship = this.enabledShips[this.selectedShipIndex];
      if (ship) {
        return ship.items.filter((v) => v.fullSlot);
      }
      return [];
    },
    displayEnemies(): Enemy[] {
      if (this.displayPrincess) {
        return this.enemies;
      }
      return this.enemies.filter((v) => v.data.id <= 1600);
    },
    isManualItem(): boolean {
      const item = this.items[this.selectedItemIndex];
      if (item) {
        return item.fullSlot !== this.slot || item.data.asw !== this.asw;
      }
      return true;
    },
  },
  methods: {
    clickedShip(index: number) {
      this.selectedShipIndex = index;
      const item = this.items[this.selectedItemIndex];

      // なんか違う装備だったら探してみる
      if (!item || !item.fullSlot) {
        const newItemIndex = this.items.findIndex((v) => v.fullSlot && v.data.asw);
        if (newItemIndex >= 0) {
          this.selectedItemIndex = newItemIndex;
        }
      }

      this.clickedItem(this.selectedItemIndex);
    },
    clickedItem(index: number) {
      this.selectedItemIndex = index;
      const item = this.items[index];
      if (item) {
        this.slot = item.fullSlot;
        this.asw = item.data.asw;
      } else {
        this.slot = 0;
        this.asw = 0;
      }

      this.calculate();
    },
    calculate() {
      // 検証
      if (!this.asw || this.asw < 0) {
        this.asw = 0;
      }
      if (!this.slot || this.slot < 0) {
        this.slot = 0;
      }
      if (this.asw > 999) {
        this.asw = 999;
      }
      if (this.slot > 999) {
        this.slot = 999;
      }

      const powers = AerialFirePowerCalculator.getAswSupportForePowers(this.asw, this.slot, this.isCritical);
      this.powers = powers.map((v) => `${Math.floor(100 * v.power) / 100}(${100 * v.rate}%)`);

      const enemies = this.displayEnemies;
      this.enemyRows = [];
      for (let i = 0; i < enemies.length; i += 1) {
        const enemy = enemies[i];
        const HP = enemy.data.hp;

        // 火力分布より、被ダメージ分布を取得
        const damageDist = CommonCalc.getDamageDistribution(powers, enemy.actualArmor, 1, HP, true);
        const damages = damageDist.map((v) => v.damage);

        // 最低 最大ダメ
        const minDamage = min(damages) as number;
        const maxDamage = max(damages) as number;

        // 各損傷状態必要ダメージボーダーとその確率 [死, 大, 中]
        const damageBorders = [
          { min: HP, max: maxDamage + 1, rate: 0 },
          { min: Math.ceil(HP * 0.75), max: HP, rate: 0 },
          { min: Math.ceil(HP * 0.5), max: Math.ceil(HP * 0.75), rate: 0 },
        ];

        for (let j = 0; j < damageBorders.length; j += 1) {
          const obj = damageBorders[j];
          const borderMin = obj.min;
          const borderMax = obj.max;
          // 各損傷状態を満たすボーダーを上回る確率を合計したもの => つまり〇〇率
          const okPowers = damageDist.filter((v) => v.damage >= borderMin && v.damage < borderMax).map((v) => v.rate);
          const rate = okPowers.length === damageDist.length ? 1 : (sum(okPowers) as number);
          obj.rate = rate;
        }

        // ダメージ表示調整
        const row: DamageRow = {
          enemy,
          damage: `${minDamage} ~ ${maxDamage}`,
          death: Math.floor(damageBorders[0].rate * 1000) / 10,
          taiha: Math.floor(damageBorders[1].rate * 1000) / 10,
          chuha: Math.floor(damageBorders[2].rate * 1000) / 10,
        };

        // 割合ダメージチェック
        if (minDamage === 0) {
          row.damage = `割合 ~ ${maxDamage}`;
        }
        if (maxDamage === 0) {
          row.damage = '割合';
        }
        if (this.slot <= 0) {
          row.damage = '';
          this.slot = 0;
        }
        if (this.asw <= 0) {
          row.damage = '';
          this.asw = 0;
        }

        this.enemyRows.push(row);
      }

      if (!this.displayPrincess) {
        // 装甲順
        this.enemyRows.sort((a, b) => {
          if (a.enemy.data.armor !== b.enemy.data.armor) {
            return a.enemy.data.armor - b.enemy.data.armor;
          }
          return b.enemy.data.hp - a.enemy.data.hp;
        });
      }
    },
  },
});
